export default "__VITE_ASSET__BWgPBNqY__"